import angular from 'angular';

export const FormInputDirectiveModule = angular.module('acme.common.directive.formInput', [])
.directive('formInput', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/formInput/formInput.tpl.html',
      scope: {
        errors: '=',
        fieldName: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        var watcher;

        $scope.formInput = {

          error: false,

          init: function() {
            watcher = $scope.$watch('errors', function() {
              if ($scope.errors && $scope.errors[$scope.fieldName]) {
                $scope.formInput.error = $scope.errors[$scope.fieldName].message;
              }else{
                $scope.formInput.error = false;
              }
            });

            $scope.$on('$destroy', this.onDestroy);

          },

          onDestroy: function() {
            watcher();
          }
        };

        $scope.formInput.init();

      }]

    };

}]).name;
